module.exports = {"de":"German 🇩🇪","el":"Greek 🇬🇷","en":"English 🇬🇧","nl":"Dutch 🇳🇱"}